import { UltyInputText } from '@ulty/ulty-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

const CountriesOfOriginLabel = ({item}) => {
    const [t] = useTranslation()

    const countriesOfOriginArray =
      item.inventory?.countriesOfOrigin.length > 0 ?
        item.inventory?.countriesOfOrigin :
        item.countriesOfOrigin?.length > 0 ?
          item.countriesOfOrigin :
          []

    const countriesOfOriginLabel = countriesOfOriginArray.length > 0 ?
      countriesOfOriginArray.join(', ') :
      null

    if (!countriesOfOriginLabel) {
        return null
    }

    return (
      <UltyInputText
        readonly
        label={t('item_edit.countriesOfOrigin')}
        value={countriesOfOriginLabel}
      />
    )
}

export { CountriesOfOriginLabel }
